/* eslint-disable react/jsx-filename-extension */
import React, {
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import {
  AppContext,
  TabsContainer,
  getTranslatedText,
  useProduct
} from '@nile/components';

const Wrapper = styled.div`
  height: calc(100% - 50px);
`;

export const TABS = {
  ALL: 'ALL',
  TICKET: 'TICKET',
  INVOICE: 'invoice',
  QUOTE: 'QUOTE',
  TASK: 'TASK',
  ALERT: 'ALERT'
  // MENTION: 'mention'
};

const getTabs = (intl, isMSPProduct) => {
  const ALL_TABS = [
    {
      id: TABS.ALL,
      content: getTranslatedText(intl, 'notifications.tab.all'),
      iconName: 'Updates',
      accessibilityLabel: 'All',
      panelID: 'all-notifications',
      component: null
    },
    {
      id: TABS.TICKET,
      content: getTranslatedText(intl, 'notifications.tab.tickets'),
      iconName: 'TicketOutline',
      name: TABS.TICKET,
      accessibilityLabel: 'Tickets',
      panelID: 'tickets',
      component: null
    },
    {
      id: TABS.TASK,
      content: getTranslatedText(intl, 'notifications.tab.task'),
      iconName: 'Tasks',
      name: TABS.TASK,
      accessibilityLabel: 'tasks',
      panelID: 'all-tasks',
      component: null
    },
    {
      id: TABS.ALERT,
      content: getTranslatedText(intl, 'notifications.tab.alert'),
      iconName: 'AlertIcon',
      name: TABS.ALERT,
      accessibilityLabel: 'alerts',
      panelID: 'all-alerts',
      component: null
    }
  ];
  if (isMSPProduct) {
    ALL_TABS.splice(
      2,
      0,
      {
        id: TABS.INVOICE,
        content: getTranslatedText(intl, 'notifications.tab.invoice'),
        iconName: 'InvoiceLogo',
        name: TABS.INVOICE,
        accessibilityLabel: 'Invoices',
        panelID: 'all-invoices',
        component: null
      },
      {
        id: TABS.QUOTE,
        content: getTranslatedText(intl, 'notifications.tab.quote'),
        iconName: 'Info',
        name: TABS.QUOTE,
        accessibilityLabel: 'Quote',
        panelID: 'all-quotes',
        component: null
      }
    );
  }
  return ALL_TABS;
};
interface ITabsProps {
  tabChildren: ReactNode;
  onTabChange: (tabId: string) => void;
}
function Tabs({ tabChildren, onTabChange }: ITabsProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const isMSPProduct = useProduct('MSP');

  const intl = useIntl();

  const tabs = useMemo(
    () =>
      getTabs(intl, isMSPProduct).map((item) => ({
        ...item,
        component: tabChildren
      })),
    [tabChildren]
  );
  return (
    <Wrapper>
      <TabsContainer
        activeTabIndex={activeIndex}
        tabs={tabs}
        onTabChange={useCallback(
          (index) => {
            setActiveIndex(index);
            onTabChange(tabs[index].id);
          },
          [onTabChange, tabs]
        )}
      />
    </Wrapper>
  );
}

export default Tabs;
